module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#thump",
      toString: function () {
        return this.url;
      }
    }